import InvitationStages from "features/identity/invitation/invitationStages";
import WaiverSubmit from "features/waivers/submit/WaiverSubmit";
import WaiverSubmitForm from "features/waivers/submit/WaiverSubmitForm";
import WaiverSubmitList from "features/waivers/submit/WaiverSubmitList";
import { Route } from "react-router-dom";
import OpenapiDocs from "../features/openapis/docs/OpenapiDocs";

export const SharedPublicRoutes = (
  <>
    <Route path="openapi-docs" element={<OpenapiDocs />} />
    <Route path="accept-invitation/:token/" element={<InvitationStages />} />
    <Route path="sharing/:token/" element={<WaiverSubmit />}>
      <Route path="" element={<WaiverSubmitList />} />
      <Route path=":waiver_id" element={<WaiverSubmitForm />} />
    </Route>
  </>
);
